import { ENTRETIEN_INITIAL } from '../../donnees/entretien-initial.js';
/** Référentiel de l'accueil par vocal : données versionnées, jamais du code en dur (PAR-36, REF-TYP, #38). */
export type TypeDemande = 'succession' | 'regularisation_terrain';

export interface ReferentielAccueil {
  version: string;
  /** PAR-36 : année avant laquelle un titre est « ancien » (seuil décidé par Isabelle, modifiable). */
  seuilTitreAncienAnnee: number;
  /** `typeCode` : type de mission du dossier créé ; `titreDossier` : titre, `{proprietaire}` remplacé. */
  types: readonly { code: TypeDemande; libelle: string; typeCode: string; titreDossier: string }[];
  questions: { type: string; proprietaire: string; naissance: string };
  alerteTitreAncien: string;
  /** Enregistrement de l'entretien sans vocal (D16, 26/10) : textes de l'écran et du compte rendu d'entretien. */
  enregistrement: {
    bouton: string;
    enCours: string;
    titreCompteRendu: string;
    dossierCree: string;
    auDossier: string;
    lienDossier: string;
  };
}

const PAR_TYPE: Readonly<Record<TypeDemande, { typeCode: string; titreDossier: string }>> = {
  succession: { typeCode: 'TYP-01', titreDossier: 'Succession {proprietaire}' },
  regularisation_terrain: { typeCode: 'TYP-02', titreDossier: 'Régularisation {proprietaire}' },
};
const OBJET = ENTRETIEN_INITIAL.questions.find((q) => q.code === 'objet')!;
const question = (code: string): string => ENTRETIEN_INITIAL.questions.find((q) => q.code === code)!.question;

export const REFERENTIEL_ACCUEIL: ReferentielAccueil = {
  version: '2026-10-17',
  seuilTitreAncienAnnee: 1970,
  // Questions et choix : la donnée commune de l'entretien initial (M02 et D16, unifiée le 26/10). Ici seulement ce qui est propre à
  // l'accueil : le type de mission et le titre du dossier créé, par réponse.
  types: OBJET.options!.map((o) => ({ code: o.code as TypeDemande, libelle: o.libelle, ...PAR_TYPE[o.code as TypeDemande] })),
  questions: { type: OBJET.question, proprietaire: question('proprietaire_origine'), naissance: question('date_naissance_proprietaire') },
  alerteTitreAncien: 'Titre ancien : un géomètre peut être nécessaire. La recherche de titre le proposera à l’étape concernée.',
  enregistrement: {
    bouton: 'Enregistrer l’entretien',
    enCours: 'Enregistrement en cours…',
    titreCompteRendu: 'Entretien d’accueil du {date}',
    dossierCree: 'Entretien enregistré : le dossier {reference} est créé, avec le compte rendu de l’entretien à relire. Cabinet MAAT',
    auDossier: 'Entretien enregistré au dossier, avec son compte rendu à relire. Cabinet MAAT',
    lienDossier: 'Ouvrir le dossier',
  },
};
